import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import Overlay from '@veeva/corgix/overlay';
import Icon from '@veeva/corgix/icon';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';

const propTypes = {
    backgroundColorDisabled: PropTypes.bool,
    overlayMaskDisabled: PropTypes.bool,
};

// overlay mask that covers the entire screen with a spinner in the middle
const Loading = ({ backgroundColorDisabled, overlayMaskDisabled }) => {
    const CSS = [
        css`
            background-color: rgba(255, 255, 255, 0.3);
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        `,
        backgroundColorDisabled &&
            css`
                background-color: rgba(255, 255, 255, 0);
            `,
        overlayMaskDisabled &&
            css`
                pointer-events: none;
            `,
    ];

    return (
        <Overlay open>
            <div css={CSS}>
                <Icon spin type={faSpinner} color="#555555" size="xl" />
            </div>
        </Overlay>
    );
};

Loading.propTypes = propTypes;
export default Loading;
